module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Chat#2-dec5d2cf9e017758d2aec3c111d72a7d.svg";